module.exports = __webpack_public_path__ + "img/2-17.8e989936.jpg";